import { useState } from 'react';
import { ChangePassword } from '../sections/changePassword/ChangePassword';
import { useAdminToast } from '../shell/AdminToastContext';

export const ContrasenaPage = () => {
    const toast = useAdminToast();
    const [changePassword, setChangePassword] = useState([]);
    const [getExpirationDate, setGetExpirationDate] = useState({});

    return (
        <ChangePassword
            changePassword={changePassword}
            setChangePassword={setChangePassword}
            getExpirationDate={getExpirationDate}
            setGetExpirationDate={setGetExpirationDate}
            toast={toast}
            selectedPerson={'pf'}
        />
    );
};

export default ContrasenaPage;
